/**
 * New Homepage — JavaScript
 * Italian Home × Mubkhar
 *
 * Modules:
 *   A. Sticky Header (hide/show on scroll)
 *   B. Mobile Navigation Drawer
 *   C. Product Tabs (Shop By section)
 *   D. Collection Slider (Explore the World of Mubkhar)
 *   E. Art of Scent Carousel (with dots + swipe)
 *   F. Scroll Reveal Animations (IntersectionObserver)
 *   G. Newsletter Form
 */

(function () {
  'use strict';


  /* =========================================================================
     C. PRODUCT TABS — Shop By Section
  ========================================================================= */
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.product-tab-content');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.tab;

      // Deactivate all
      tabBtns.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      tabContents.forEach(c => {
        c.classList.remove('active');
        c.hidden = true;
      });

      // Activate selected
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.add('active');
        targetContent.hidden = false;
      }
    });
  });

  // Initialize hidden states
  tabContents.forEach((c, i) => {
    if (i !== 0) c.hidden = true;
  });

  /* =========================================================================
     D. COLLECTION SLIDER — Explore the World of Mubkhar
  ========================================================================= */
  const sliderTrack = document.querySelector('.slider-track');
  const sliderPrev = document.getElementById('slider-prev');
  const sliderNext = document.getElementById('slider-next');

  if (sliderTrack && sliderPrev && sliderNext) {
    const sliderCards = sliderTrack.querySelectorAll('.collection-card-slide');
    let sliderOffset = 0;
    let sliderMax = 0;

    function getSliderCardWidth() {
      return sliderCards[0] ? sliderCards[0].offsetWidth + 24 : 0; // 24 = gap
    }

    function updateSliderMax() {
      sliderMax = Math.max(0, sliderTrack.scrollWidth - sliderTrack.parentElement.offsetWidth);
    }
    updateSliderMax();
    window.addEventListener('resize', updateSliderMax);

    sliderNext.addEventListener('click', () => {
      sliderOffset = Math.min(sliderOffset + getSliderCardWidth(), sliderMax);
      sliderTrack.style.transform = `translateX(-${sliderOffset}px)`;
    });

    sliderPrev.addEventListener('click', () => {
      sliderOffset = Math.max(0, sliderOffset - getSliderCardWidth());
      sliderTrack.style.transform = `translateX(-${sliderOffset}px)`;
    });

    // Touch / swipe
    let sliderTouchStartX = 0;
    sliderTrack.addEventListener('touchstart', e => {
      sliderTouchStartX = e.touches[0].clientX;
    }, { passive: true });
    sliderTrack.addEventListener('touchend', e => {
      const diff = sliderTouchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          sliderOffset = Math.min(sliderOffset + getSliderCardWidth(), sliderMax);
        } else {
          sliderOffset = Math.max(0, sliderOffset - getSliderCardWidth());
        }
        sliderTrack.style.transform = `translateX(-${sliderOffset}px)`;
      }
    }, { passive: true });
  }

  /* =========================================================================
     E. ART OF SCENT CAROUSEL — horizontal carousel with dots + swipe
  ========================================================================= */
  const artTrack = document.getElementById('art-carousel-track');
  const artPrevBtn = document.getElementById('art-carousel-prev');
  const artNextBtn = document.getElementById('art-carousel-next');
  const artDotsEl = document.getElementById('art-carousel-dots');

  if (artTrack && artPrevBtn && artNextBtn) {
    const artCards = artTrack.querySelectorAll('.art-carousel-card');
    let artOffset = 0;
    let artMax = 0;
    let artCardW = 0;
    let visibleCount = 0;
    let dotCount = 0;
    let currentDotIndex = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragDelta = 0;

    function getArtCardWidth() {
      if (artCards.length === 0) return 0;
      const card = artCards[0];
      const style = window.getComputedStyle(artTrack);
      const gap = parseFloat(style.gap) || 24;
      return card.offsetWidth + gap;
    }

    function getVisibleCount() {
      const wrapper = artTrack.parentElement;
      if (!wrapper || artCards.length === 0) return 1;
      const wrapperW = wrapper.offsetWidth;
      const cardW = artCards[0].offsetWidth;
      return Math.round(wrapperW / cardW) || 1;
    }

    function buildDots() {
      if (!artDotsEl) return;
      artDotsEl.innerHTML = '';
      visibleCount = getVisibleCount();
      dotCount = artCards.length - visibleCount + 1;
      if (dotCount < 2) { artDotsEl.style.display = 'none'; return; }
      artDotsEl.style.display = 'flex';

      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'art-carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => goToSlide(i));
        artDotsEl.appendChild(dot);
      }
    }

    function updateDots(index) {
      const dots = artDotsEl ? artDotsEl.querySelectorAll('.art-carousel-dot') : [];
      dots.forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
      currentDotIndex = index;
    }

    function goToSlide(index) {
      artCardW = getArtCardWidth();
      artMax = Math.max(0, artTrack.scrollWidth - artTrack.parentElement.offsetWidth);
      artOffset = Math.min(artCardW * index, artMax);
      artTrack.style.transform = `translateX(-${artOffset}px)`;
      updateDots(Math.round(artOffset / (artCardW || 1)));
    }

    function calcCurrentDotIndex() {
      artCardW = getArtCardWidth();
      if (!artCardW) return 0;
      return Math.round(artOffset / artCardW);
    }

    function initArtCarousel() {
      artCardW = getArtCardWidth();
      artMax = Math.max(0, artTrack.scrollWidth - artTrack.parentElement.offsetWidth);
      buildDots();
      updateDots(0);
    }

    artNextBtn.addEventListener('click', () => {
      artCardW = getArtCardWidth();
      artMax = Math.max(0, artTrack.scrollWidth - artTrack.parentElement.offsetWidth);
      artOffset = Math.min(artOffset + artCardW, artMax);
      artTrack.style.transform = `translateX(-${artOffset}px)`;
      updateDots(calcCurrentDotIndex());
    });

    artPrevBtn.addEventListener('click', () => {
      artCardW = getArtCardWidth();
      artOffset = Math.max(0, artOffset - artCardW);
      artTrack.style.transform = `translateX(-${artOffset}px)`;
      updateDots(calcCurrentDotIndex());
    });

    /* Touch swipe */
    let artTouchStartX = 0;
    artTrack.addEventListener('touchstart', e => {
      artTouchStartX = e.touches[0].clientX;
    }, { passive: true });
    artTrack.addEventListener('touchend', e => {
      const diff = artTouchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        artCardW = getArtCardWidth();
        artMax = Math.max(0, artTrack.scrollWidth - artTrack.parentElement.offsetWidth);
        if (diff > 0) {
          artOffset = Math.min(artOffset + artCardW, artMax);
        } else {
          artOffset = Math.max(0, artOffset - artCardW);
        }
        artTrack.style.transform = `translateX(-${artOffset}px)`;
        updateDots(calcCurrentDotIndex());
      }
    }, { passive: true });

    /* Mouse drag */
    artTrack.addEventListener('mousedown', e => {
      isDragging = true;
      dragStartX = e.clientX;
      dragDelta = 0;
      artTrack.style.transition = 'none';
      e.preventDefault();
    });
    window.addEventListener('mousemove', e => {
      if (!isDragging) return;
      dragDelta = dragStartX - e.clientX;
    });
    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      artTrack.style.transition = '';
      if (Math.abs(dragDelta) > 40) {
        artCardW = getArtCardWidth();
        artMax = Math.max(0, artTrack.scrollWidth - artTrack.parentElement.offsetWidth);
        if (dragDelta > 0) {
          artOffset = Math.min(artOffset + artCardW, artMax);
        } else {
          artOffset = Math.max(0, artOffset - artCardW);
        }
        artTrack.style.transform = `translateX(-${artOffset}px)`;
        updateDots(calcCurrentDotIndex());
      }
    });

    // Initialize and re-init on resize
    initArtCarousel();
    window.addEventListener('resize', () => {
      artOffset = 0;
      artTrack.style.transform = 'translateX(0)';
      initArtCarousel();
      updateDots(0);
    });
  }

  /* =========================================================================
     F. SCROLL REVEAL ANIMATIONS — IntersectionObserver
  ========================================================================= */
  const revealEls = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    const revealIO = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          revealIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => revealIO.observe(el));
  } else {
    // Fallback: show all immediately
    revealEls.forEach(el => el.classList.add('in-view'));
  }

  /* =========================================================================
     G. NEWSLETTER FORM
  ========================================================================= */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      e.preventDefault();
      const input = newsletterForm.querySelector('input[type="email"]');
      const btn = newsletterForm.querySelector('button[type="submit"]');
      if (input && btn) {
        btn.textContent = '✓ Subscribed!';
        btn.disabled = true;
        input.value = '';
        setTimeout(() => {
          btn.textContent = 'Subscribe';
          btn.disabled = false;
        }, 4500);
      }
    });
  }



  /* ------------------------------------------------------------------ *
    * Pick N Variants Bundle Widget (product page)
    * Fixed-price bundle: customer picks `requiredCount` units total,
    * mixing variants freely or taking one variant multiple times.
    * Adds each selected variant to cart with a shared `_bundle_id`
    * line item property so the Cart Transform Function can merge
    * them into a single cart/checkout line.
    * ------------------------------------------------------------------ */

  function initAddonBundleBuilder() {
    const roots = document.querySelectorAll('[data-addon-bundle]');
    if (!roots.length) return;
    roots.forEach((root) => setupAddonBundle(root));
  }

  function setupAddonBundle(root) {
    const requiredCount = parseInt(root.dataset.requiredCount, 10) || 3;
    const mainVariantId = root.dataset.mainVariantId;

    const items = Array.from(root.querySelectorAll('[data-addon-item]')).map((el) => {
      const checkbox = el.querySelector('[data-addon-checkbox]');
      return {
        el,
        variantId: el.dataset.variantId,
        variantName: el.dataset.variantName || el.querySelector('.w-addon-bundle__item-title')?.textContent?.trim() || 'Variant',
        available: el.dataset.available === 'true',
        checkbox,
        qtyWrap: el.querySelector('[data-addon-qty-wrap]'),
        qtyInput: el.querySelector('[data-addon-qty-input]'),
        btnMinus: el.querySelector('[data-addon-qty-minus]'),
        btnPlus: el.querySelector('[data-addon-qty-plus]'),
      };
    });

    const counterEl = root.querySelector('[data-addon-bundle-selected-count]');
    const submitBtn = root.querySelector('[data-addon-bundle-submit]');
    const errorEl   = root.querySelector('[data-addon-bundle-error]');

    function totalSelected() {
      return items.reduce((sum, item) => {
        if (item.checkbox && item.checkbox.checked && item.qtyInput) {
          return sum + parseInt(item.qtyInput.value, 10) || 1;
        }
        return item.checkbox && item.checkbox.checked ? sum + 1 : sum;
      }, 0);
    }

    function render() {
      const selected = totalSelected();

      items.forEach((item) => {
        if (!item.checkbox) return;
        const isChecked = item.checkbox.checked;
        item.el.classList.toggle('is-selected', isChecked);

        if (item.qtyWrap) {
          item.qtyWrap.hidden = !isChecked;
        }

        if (!item.available) {
          item.checkbox.disabled = true;
        } else if (selected >= requiredCount && !isChecked) {
          item.checkbox.disabled = true;
        } else {
          item.checkbox.disabled = false;
        }

        if (item.btnPlus && item.btnMinus && item.qtyInput) {
          const qty = parseInt(item.qtyInput.value, 10) || 1;
          item.btnMinus.disabled = qty <= 1;
          item.btnPlus.disabled = selected >= requiredCount || qty >= requiredCount;
        }
      });

      if (counterEl) counterEl.textContent = selected;
      if (submitBtn) submitBtn.disabled = selected !== requiredCount;
      if (errorEl) errorEl.hidden = true;
    }

    items.forEach((item) => {
      if (!item.available || !item.checkbox) return;

      item.checkbox.addEventListener('change', () => {
        if (item.qtyInput) {
          item.qtyInput.value = 1;
        }
        if (totalSelected() > requiredCount) {
          item.checkbox.checked = false;
        }
        render();
      });

      if (item.btnMinus && item.btnPlus && item.qtyInput) {
        item.btnMinus.addEventListener('click', (e) => {
          e.stopPropagation();
          const currentQty = parseInt(item.qtyInput.value, 10) || 1;
          if (currentQty > 1) {
            item.qtyInput.value = currentQty - 1;
            render();
          }
        });
        item.btnPlus.addEventListener('click', (e) => {
          e.stopPropagation();
          const currentQty = parseInt(item.qtyInput.value, 10) || 1;
          if (totalSelected() < requiredCount) {
            item.qtyInput.value = currentQty + 1;
            render();
          }
        });
      }

      item.el.addEventListener('click', (e) => {
        if (e.target.closest('.w-addon-bundle__checkbox-wrap') || e.target.closest('.w-addon-bundle__qty-wrap')) return;
        if (item.checkbox.disabled && !item.checkbox.checked) return;

        item.checkbox.checked = !item.checkbox.checked;
        if (item.qtyInput) {
          item.qtyInput.value = 1;
        }
        if (item.checkbox.checked && totalSelected() > requiredCount) {
          item.checkbox.checked = false;
        }
        render();
      });
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', () => {
        const selected = totalSelected();
        if (selected !== requiredCount) {
          errorEl.textContent = `Please select exactly ${requiredCount} items (currently ${selected} selected).`;
          errorEl.hidden = false;
          return;
        }
        addBundleToCart();
      });
    }

    async function addBundleToCart() {
      submitBtn.disabled = true;
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';

      const selectedItems = items.filter((item) => item.checkbox && item.checkbox.checked);
      const bundleSelections = selectedItems
        .map((item) => {
          const qty = item.qtyInput ? parseInt(item.qtyInput.value, 10) : 1;
          return qty > 1 ? `${item.variantName} (x${qty})` : item.variantName;
        })
        .join(', ');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: mainVariantId,
              quantity: 1,
              properties: {
                _bundle_selections: bundleSelections,
              },
            }],
          }),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Cart add failed');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      } catch (err) {
        errorEl.textContent = err.message || 'Something went wrong, please try again.';
        errorEl.hidden = false;
        console.error('[addon-bundle] add to cart failed:', err);
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }

    render();
  }


  function generateBundleId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `b_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  }

  document.addEventListener('DOMContentLoaded', initAddonBundleBuilder);








})();


/* =========================================================================
   H. Collections tabs (side by side)
========================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-tabs-section').forEach(function (section) {
    const tabs = section.querySelectorAll('.collection-tab');
    const containers = section.querySelectorAll('.collection-products');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(tab);
        }
      });
    });

    function activateTab(tab) {
      const handle = tab.dataset.handle;
      const seeAllTemplate = section.querySelector('.see-all-button');
      const seeAllText = seeAllTemplate ? seeAllTemplate.textContent.trim() : 'See All';
      const seeAllHref = tab.dataset.collectionUrl || '#';

      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
        const existingLink = t.querySelector('.see-all-button');
        if (existingLink) existingLink.remove();
      });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      containers.forEach(function (c) {
        c.classList.add('hidden');
        if (c.dataset.handle === handle) c.classList.remove('hidden');
      });

      const seeAll = document.createElement('a');
      seeAll.className = 'see-all-button';
      seeAll.href = seeAllHref;
      seeAll.innerText = seeAllText;
      tab.appendChild(seeAll);
    }

    // Add-to-cart handling
    section.querySelectorAll('.product-card__atc').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding...';

        fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            button.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 1500);
          })
          .catch(function () {
            button.textContent = 'Error';
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 1500);
          });
      });
    });
  });





});
